<template>
    <div class="full-height">
        <ContainerXxl>
            <Breadcrumbs/>
            <div class="mb-3">
                <div class="row mt-4">
                    <div class="col-12 col-lg-9 order-1 order-lg-0">
                        <slot/>
                    </div>
                    <div class="col-12 col-lg-3 order-0 order-lg-1 mb-5 mb-lg-0">
                        <div class="w-100">
                            <input
                                class="form-control form-search"
                                type="search"
                                v-model="searchValue"
                                :placeholder="$t('Search')"
                                :aria-label="$t('Search')"
                                @keydown="onSearch"
                            />
                        </div>
<!--                        <div>-->
<!--                            <ProductsByTag tag="top-seller" metals="gold,silver"/>-->
<!--                        </div>-->
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-9">
                        <tags :tags="tags" />
                    </div>
                </div>
            </div>
        </ContainerXxl>
    </div>
</template>

<script setup>
import {ref, watch} from "vue";
import {useRoute, useRouter} from "vue-router";
const ContainerXxl = defineAsyncComponent(() => import('~/layouts/container-xxl.vue'));

const Tags = defineAsyncComponent(() => import("./tags.vue"));

const props = defineProps({
    tags: Array
});

const emit = defineEmits(['search']);

const route = useRoute();
const router = useRouter();

const searchValue = ref(route.query.search || '');

function onSearch(event) {
    if (event.key !== 'Enter') {
        return;
    }

    const search = event.target.value;
    emit('search', search);
    const query = { ...route.query, search };
    if (!search) {
        delete query.search;
    }

    const locale = useNuxtApp().$i18n.locale.value;

    router.push({
        path: `/${locale}/blog/`,
        query
    });
}

watch(searchValue, (newValue) => {
    if (newValue === '') {
        emit('search', '');
        const query = { ...route.query };
        delete query.search;
        router.push({
            path: route.path,
            query,
        });
    }
});
</script>
